"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SunburstPageEventByFrustrationLevel = exports.SunburstPageEventRequestGroupBy = void 0;
var SunburstPageEventRequestGroupBy;
(function (SunburstPageEventRequestGroupBy) {
    SunburstPageEventRequestGroupBy["DEVICE"] = "device";
    SunburstPageEventRequestGroupBy["SOURCE"] = "source";
    SunburstPageEventRequestGroupBy["FRUSTRATION_INDICATOR"] = "frustrationIndicator";
    SunburstPageEventRequestGroupBy["FRUSTRATION_LEVEL"] = "frustrationLevel";
})(SunburstPageEventRequestGroupBy = exports.SunburstPageEventRequestGroupBy || (exports.SunburstPageEventRequestGroupBy = {}));
var SunburstPageEventByFrustrationLevel;
(function (SunburstPageEventByFrustrationLevel) {
    SunburstPageEventByFrustrationLevel["LOW"] = "low";
    SunburstPageEventByFrustrationLevel["MID"] = "mid";
    SunburstPageEventByFrustrationLevel["HIGH"] = "high";
})(SunburstPageEventByFrustrationLevel = exports.SunburstPageEventByFrustrationLevel || (exports.SunburstPageEventByFrustrationLevel = {}));
//# sourceMappingURL=sunburst.page-events.models.js.map